<template>
<div class="content-body tenant-settings">
    <div class="">
        <div>
            <el-row><span style="color:red">只填写专用模具、夹具、检具的费用（专用的概念：只能用于本零件，如果本零件停产，则模具、夹具、检具无法继续使用生产别的零件）</span></el-row>
        </div>
        <!-- 模具、夹具、检具成本-->
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="mini">
            <el-form-item label="工序:">
              <el-input size="mini" v-model="dataForm.process" placeholder="请输入工序名称" clearable @blur="getDataList"></el-input>
<!--              <el-select size="mini" v-model="dataForm.process" placeholder="请选择工序" clearable @change="getDataList">-->
<!--                    <el-option v-for="item in PROCESS" :key="item.value" :label="item.label" :value="item.value"></el-option>-->
<!--                </el-select>-->
            </el-form-item>
            <el-form-item label="模具/夹具/检具名称:">
                <el-input size="mini" v-model="dataForm.moldFixtureCheckingToolName" placeholder="模具/夹具/检具名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
              <el-button size="mini" :loading="saveDisabled" type="primary" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'"  plain @click="save()">
                <span class="font-12 iconfont myicon-tongguo"></span>&nbsp;保存
              </el-button>
                <el-button size="mini" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
<!--                <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">-->
<!--                    新建-->
<!--                </el-button>-->
              <el-button size="mini" v-if="isAuth('portal:quotation:newbuttonDetail') && viewFlag !== 'view'" type="primary" plain @click="addHandleNewRow()" icon="el-icon-plus">
                新增
              </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
          <el-table-edit
              v-model="dataList"
              :columns="['supplierName','roundNo', 'process','moldFixtureCheckingToolName'
          ,'resinDieCastingStampingDieWeight','selfMade','outsourcing','makingTime','totalInvestment','totalNumberOfTheSameMold','numberPerModulus','payRatio'
          ,'life','amortizationPrice','amortizationNum','partAllocation']"
              ref="editTable"
          >
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%" :default-expand-all="false" border
                      :header-cell-style="{background:'#f5f5f5'}" :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="supplierName" header-align="center" align="left" label="供应商名称" width="200">
                  <template slot-scope="{ row }">
                  <el-table-edit-cell
                      :row="row"
                      prop="supplierName"
                  >
                    <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.supplierName}}</span>
                        <el-input size="mini" v-show="rowStates.editing" v-model="row.supplierName" placeholder="请输入供应商名称" clearable></el-input>
                    </template>
                  </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="process" header-align="center" align="center" label="工序" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="process"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.process}}</span>
                        <el-input size="mini" v-show="rowStates.editing" v-model="row.process" placeholder="请输入工序名称" clearable></el-input>

<!--                        <span v-show="!rowStates.editing">{{getprocessByValue(row.process)}}</span>
                        <el-select v-show="rowStates.editing" size="mini" v-model="row.process" placeholder="请选择工序" clearable>
                          <el-option v-for="item in PROCESS" :key="item.value" :label="item.label" :value="item.value" />
                        </el-select>-->
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="moldFixtureCheckingToolName" header-align="center" align="left" label="模具/夹具/检具名称" width="150">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="moldFixtureCheckingToolName"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.moldFixtureCheckingToolName}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.moldFixtureCheckingToolName"
                            clearable
                            placeholder="模具/夹具/检具名称"
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="resinDieCastingStampingDieWeight" header-align="center" align="right" label="树脂、压铸、冲压模具重量" width="180">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="resinDieCastingStampingDieWeight"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.resinDieCastingStampingDieWeight | digit3}}</span>
                        <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.resinDieCastingStampingDieWeight" placeholder="树脂、压铸、冲压模具重量"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="selfMade" header-align="center" align="right" label="自制/外协" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="selfMade"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.selfMade}}</span>
                        <el-select size="mini" v-show="rowStates.editing" v-model="row.selfMade" placeholder="请选择" clearable>
                            <el-option v-for="item in selfMadeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>


                        <!-- <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.selfMade"
                            clearable
                            placeholder="自制"
                        >
                        </el-input> -->
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="outsourcing" header-align="center" align="right" label="外协" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="outsourcing"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.outsourcing}}</span>
                        <el-input
                            size="mini"
                            v-show="rowStates.editing"
                            v-model="row.outsourcing"
                            clearable
                            placeholder="外协"
                        >
                        </el-input>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column> -->
                <el-table-column prop="makingTime" header-align="center" align="right" label="制造周期" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="makingTime"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.makingTime | digit3}}</span>
                        <ctl-number v-show="rowStates.editing" v-model="row.makingTime" placeholder="制造周期"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="totalInvestment" header-align="center" align="right" label="总投资额" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="totalInvestment"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.totalInvestment | digit3}}</span>
                        <ctl-number :precision="3" :min="0" v-show="rowStates.editing" v-model="row.totalInvestment" placeholder="总投资额"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="totalNumberOfTheSameMold" header-align="center" align="right" label="同种模具总数" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="totalNumberOfTheSameMold"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.totalNumberOfTheSameMold | digit3}}</span>
                        <ctl-number :min="0" v-show="rowStates.editing" v-model="row.totalNumberOfTheSameMold" placeholder="同种模具总数"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="numberPerModulus" header-align="center" align="right" label="每模取数" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="numberPerModulus"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.numberPerModulus}}</span>
                        <ctl-number :min="0" v-show="rowStates.editing" v-model="row.numberPerModulus" placeholder="每模取数"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="payRatio" header-align="center" align="right" label="支付比例 | %" width="100">
                <template slot-scope="{ row }">
                  <el-table-edit-cell
                      :row="row"
                      prop="payRatio"
                  >
                    <template slot-scope="{ rowStates}">
                      <span v-show="!rowStates.editing">{{row.payRatio}}%</span>
                      <ctl-number :min="0" v-show="rowStates.editing" v-model="row.payRatio" placeholder="支付比例"></ctl-number>
                    </template>
                  </el-table-edit-cell>
                </template>
              </el-table-column>
                <el-table-column prop="life" header-align="center" align="right" label="寿命" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="life"
                    >
                      <template slot-scope="{ rowStates}">
                        <span v-show="!rowStates.editing">{{row.life}}</span>
                        <ctl-number :min="0" v-show="rowStates.editing" v-model="row.life" placeholder="寿命"></ctl-number>
                      </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="amortizationPrice" header-align="center" align="right" label="摊销金额" width="100">
                <template slot-scope="{ row }">
                  <el-table-edit-cell
                    :row="row"
                    prop="amortizationPrice"
                  >
                    <template>
                       <span>
                         {{
                           isNaN((row.totalInvestment*(1- row.payRatio/100)).toFixed(4))?
                               0:(row.totalInvestment*(1- row.payRatio/100)).toFixed(4)
                         }}
                       </span>
                    </template>
                   </el-table-edit-cell>
                </template>
              </el-table-column>
              <el-table-column prop="amortizationNum" header-align="center" align="right" label="摊销数量" width="100">
                <template slot-scope="{ row }">
                  <el-table-edit-cell
                      :row="row"
                      prop="amortizationNum"
                  >
                    <template slot-scope="{ rowStates}">
                      <span v-show="!rowStates.editing">{{row.amortizationNum}}</span>
                      <ctl-number :min="0" v-show="rowStates.editing" v-model="row.amortizationNum" placeholder="摊销数量"></ctl-number>
                    </template>
                  </el-table-edit-cell>
                </template>
              </el-table-column>
                <el-table-column prop="partAllocation" header-align="center" align="right" label="摊销单价" width="100">
                  <template slot-scope="{ row }">
                    <el-table-edit-cell
                        :row="row"
                        prop="partAllocation"
                    >
                  <template>
                  <span>
                    {{
                      parseInt(row.amortizationNum) > 0 ?
                          (isNaN(((row.totalInvestment * (1-row.payRatio/100)) / row.amortizationNum).toFixed(4))?
                          0:((row.totalInvestment * (1-row.payRatio/100)) / row.amortizationNum).toFixed(4)):0
                    }}
                  </span>
                  </template>
                    </el-table-edit-cell>
                  </template>
                </el-table-column>
                <el-table-column prop="roundNo" width="150" header-align="center" align="right" label="报价轮次">
                </el-table-column>
                <el-table-column header-align="center" align="left" width="190" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" size="small" :disabled="viewFlag != 'view'? false :true" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" size="small" :disabled="viewFlag != 'view'? false :true" @click="deleteHandle(scope.row)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
          </el-table-edit>
            <!-- 分页 -->
            <!-- <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination> -->
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" @getDataListAll="getDataListAll"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    addPartPrice,
    editPartPrice,
    fetchToolsCostList,
    deleteToolsCost,
    createToolsCostBatch,
    getQuotationDetail
} from "@/controller/quotation";
import {
    PROCESS,
    getprocessByValue
} from '@/utils/const'
import AddOrUpdate from "./quotationToolsCost-add-or-update";
import moment from "moment";
import CtlNumber from '@/views/common/ctl-number'
// require('@/mock/mockTech');
import Decimal from 'decimal.js';

export default {
    props: {
        roundNo: Number,
        dataFromParent: Object
    },
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                process: "",
                roundNo:'',
                vender:{
                  venderName:'', //供应商名称
                  venderCode:'', //供应商编码
                },
              moldFixtureCheckingToolName: "",
            },
            selfMadeList:[{value: '自制', label: '自制'},{value: '外协', label: '外协'}],
            viewFlag: '',
            PROCESS: PROCESS,
            getprocessByValue: getprocessByValue,
            dataList: [],
            tenantList: [],
            saveDisabled:false,
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
        };
    },
    computed: {
      editTable() {
        return this.$refs.editTable
      },
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 265
            }
        }
    },
    components: {
        AddOrUpdate,
      CtlNumber
    },
    filters:{
      digit3:function (data){
          if (data == null ){
            return data
          }

          if(Number.isNaN(Number(data))){
            return null
          }
        data = Number(data).toFixed(4)
        return Number(data)
        },
    },
    // mounted() {
    //     this.getDataList();
    // },
    methods: {
      //新一行
      getNewRowData() {
        return {
          'id':'',
          'rfqId': this.dataForm.rfqId,
          'rfqPartId': this.dataForm.rfqPartId,
          'rfqSupplierId': this.dataForm.rfqSupplierId,
          'supplierName':'',
          'process':'',
          'moldFixtureCheckingToolName':'',
          'resinDieCastingStampingDieWeight':'',
          'selfMade':'',
          'payRatio':this.dataList.length > 0 ? (this.dataList[0].payRatio?this.dataList[0].payRatio:0) : 0, //支付比例如果有值则为固定值,
          'amortizationPrice':'',
          'amortizationNum':this.dataList.length > 0 ? (this.dataList[0].amortizationNum?this.dataList[0].amortizationNum:0) : 0, //摊销数量如果有值则为固定值,
          'outsourcing':'',
          'makingTime':'',
          'totalInvestment': '',
          'totalNumberOfTheSameMold':'',
          'numberPerModulus':'',
          'life':'',
          'partAllocation':'',
          'roundNo':this.dataForm.roundNo!==null ? this.dataForm.roundNo:'0',
          'rowNum':this.rowNum
        }
      },
      // 新增行
      addHandleNewRow() {
        const newRow = this.getNewRowData()
        this.editTable.newRows([newRow])
        this.rowNum += 1
      },
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        processFormat: function (value) {
            if (!value) {
                return ''
            }
            return getprocessByValue(PROCESS, value)
        },
        init(rfqId = 0, rfqPartId = 0, supplierId = 0, roundNo = 0, viewFlag , vender = null) {
            this.dataForm.vender = vender
            this.dataForm.rfqId = rfqId
            this.dataForm.rfqPartId = rfqPartId
            this.dataForm.rfqSupplierId = supplierId
            this.dataForm.roundNo = roundNo
            this.viewFlag = viewFlag
            this.pageIndex = 1
            this.getDataList()
        },
        // 获取数据列表
        getDataList() {
            // debugger
            this.dataListLoading = true;
            fetchToolsCostList({
                pageNo: 1,
                pageSize: -1,
                ...this.dataForm,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        // 获取所有数据列表
        getDataListAll() {
            // debugger
            this.dataListLoading = true;
            fetchToolsCostList({
                pageNo: 1,
                pageSize: -1,
                ...this.dataForm,
            }).then((data) => {
                if (data && data.code === "00") {
                    this.saveSum(data.body.records)
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        fixedNumber(val) {
            if (!val) {
                return 0
            }
            return Number(Number(val).toFixed(3))
        },
        saveSum(dataListAll){
            let toolsTotalInvestment = 0;
            let amortizationPrice = 0;
            let partAllocation = 0;
            let payRatio = 0;
            let amortizationNum = 0;
            if(dataListAll.length !== 0){
                dataListAll.forEach((item) => {
                    toolsTotalInvestment += this.fixedNumber(item.totalInvestment);
                    amortizationPrice += this.fixedNumber(item.amortizationPrice);
                    partAllocation += this.fixedNumber(item.partAllocation);
                });
                payRatio = dataListAll[0].payRatio 
                amortizationNum = dataListAll[0].amortizationNum 
            }
            let params = this.dataFromParent
            params.rfqId = this.dataFromParent.rfqId
            params.toolsTotalInvestment = toolsTotalInvestment //总投资额
            params.toolsPayRatio = payRatio //支付比例
            params.toolsAmortizationNum = amortizationNum //摊销数量
            params.toolsAmortizationAmount = amortizationPrice //摊销金额
            params.toolsPartAllocation = partAllocation //分摊单价
            // 制造成本小计(D=A+B+C)
            debugger
            if(params.materialCost == null)
              params.materialCost = 0
            if(params.outsidePartCost == null)
              params.outsidePartCost = 0
            if(params.processingCost == null)
              params.processingCost = 0
            params.productionCostSum = new Decimal(params.materialCost).add(new Decimal(params.outsidePartCost))
                .add(new Decimal(params.processingCost))
            console.log("params.productionCostSum===="+params.productionCostSum);
            // 产品单价(J=D+H+I+K+L)
            params.productUnitPrice = this.fixedNumber(params.productionCostSum) + this.fixedNumber(params.midiumCostSum)
                + this.fixedNumber(params.profit) + this.fixedNumber(params.packageFee)
                + this.fixedNumber(params.transportFee)
            // 产品价格总计
            params.feeCostSum = this.fixedNumber(params.productUnitPrice) + this.fixedNumber(params.toolsPartAllocation)
                + this.fixedNumber(params.designPartAllocation) 
            if (params.id) {
                editPartPrice(params).then(data => {
                    if (data && data.code === '00') {
                        // this.dataForm.id = data.body.id;
                        // this.dataForm = data.body;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })
                        this.getDataList()
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            } else {
                addPartPrice(params).then(data => {
                    if (data && data.code === '00' && data.body) {
                        this.dataFromParent.id = data.body.id;
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                        })

                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 查看
        viewHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'view', row, this.dataFromParent.rfqId)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            let id = row ? row.id : null;
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id, 'edit', row, this.dataFromParent.rfqId)
            })
        },
        // 删除
        deleteHandle(row) {
          if (row.id === ''){
              var a = []
              a.push(row)
              this.editTable.delRows(a)
          }else {
            if (row && row.rfqId) {
              let ids = row.id ? [row.id] :
                 this.dataListSelections.map((item) => {
                   return item.id;
                 });
              getQuotationDetail({}, row.rfqId).then(data => {
                if (data && data.code === '00') {
                  if("2" != data.body.rfqStatus) {
                    this.$message.warning("询价单不是询价中状态，不允许删除报价相关信息")
                  } else {
                    this.$confirm(`确定进行删除操作?`, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                      deleteToolsCost(ids).then(data => {
                        if (data && data.code === '00') {
                          this.$message({
                             message: '操作成功',
                             type: 'success',
                             duration: 1500,
                             onClose: () => {
                               this.getDataList()
                             }
                          })
                          this.$nextTick(() => {
                               this.getDataListAll();
                          })
                        } else {
                           this.$message.error(data.msg)
                        }
                      })
                    })
                  }
                }
              })
            }
          }
      },
      //保存
      save(){
        if(this.dataList.length <= 0)
          return;
        var ins =[]
        var upd=[]

        for(let i = 0;i<this.dataList.length;i++) {
          var value = this.dataList[i];
          var payRatioValue = value.payRatio?value.payRatio:0;
          var payRatio0 = this.dataList[0].payRatio?this.dataList[0].payRatio:0
          if(payRatio0 != payRatioValue){
            this.$message({
              message: "支付比例不一致，请修正",
              type: "warning",
              duration: 1500
            });
            return ;
          }
          var amortizationNumValue = value.amortizationNum?value.amortizationNum:0;
          var amortizationNum0 = this.dataList[0].amortizationNum?this.dataList[0].amortizationNum:0
          if(amortizationNum0 != amortizationNumValue){
            this.$message({
              message: "摊销数量不一致，请修正",
              type: "warning",
              duration: 1500
            });
            return ;
          }
          if (value.id ===''){
            value.amortizationPrice = isNaN((value.totalInvestment*(1- value.payRatio/100)).toFixed(4))?
                               0:(value.totalInvestment*(1- value.payRatio/100)).toFixed(4);
            value.partAllocation = parseInt(value.amortizationNum) > 0 ?
                          (isNaN(((value.totalInvestment * (1-value.payRatio/100)) / value.amortizationNum).toFixed(4))?
                          0:((value.totalInvestment * (1-value.payRatio/100)) / value.amortizationNum).toFixed(4)):0;
            ins.push(value)
          }
        }
        if (ins.length > 0 ){
          var params = {
            "list":ins,
            "rfqId": this.dataForm.rfqId,
            "subcompanyId":this.dataFromParent.subcompanyId
          }
          // 创建零件
          this.saveDisabled = true
          createToolsCostBatch(params)
              .then((data) => {
                if (data && data.code === "00") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                    duration: 1500
                  });
                  this.$nextTick(() => {
                    this.getDataListAll();
                  })
                } else {
                  this.$message.error(data.msg);
                }
                this.getDataList()
                setTimeout(() => {
                    this.saveDisabled = false
                }, 3000)
              })
              .catch((error) => {
                console.log(error);
              });

        }
        // if (upd.length > 0 ){
        //   var params = {
        //     "list":upd
        //   }
        //   // 更新零件
        //   editToolsCostBatch(params)
        //       .then((data) => {
        //         if (data && data.code === "00") {
        //           this.$message({
        //             message: "操作成功",
        //             type: "success",
        //             duration: 1500
        //           });
        //         } else {
        //           this.$message.error(data.msg);
        //         }
        //         this.getDataList()
        //       })
        //       .catch((error) => {
        //         console.log(error);
        //       });
        //
        // }

      },
    },
};
</script>

<style lang="scss">
.input-width {
    width: 155px;
}

.button-danger {
    color: #F56C6C
}

.text-danger {
    color: #F56C6C
}

.text-success {
    color: #67C23A
}

.text-waming {
    color: #E6A23C;
}

.text-info {
    color: #909399;
}

.fr {
    float: right;
}
</style>
